import { MouseEvent, useState } from 'react'
import { toggleEmojiPicker } from 'weblite-web-emoji'
// TODO: Remove to common
import { Badge, darken, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { TextEditor } from '$comp/_app/components/chat/components/footer/components/send-field/components/text-editor'
import { EmojiIcon } from '$common/icons/emoji'
import { isPhoneOrTablet } from '$func/environmentInfo'
import { nothing } from '$func/utils'
import { toLocale } from '$func/text'
import { ForwardSendIcon } from '$common/icons/forward-send'
import { t } from '$i18n'

const StyledDiv = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.white}`,
  color: theme.palette.white,
  padding: '4px',
  width: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '24px',
  boxSizing: 'border-box',
  borderRadius: '50%',
  ':hover': {
    backgroundColor: theme.palette.secondary.main,
  },
}))

const StyleIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  width: '56px',
  height: '56px',
  ':hover': {
    backgroundColor: darken(theme.palette.secondary.main, 0.2),
  },
  boxShadow: '0px -1px 8px rgba(0, 0, 0, 0.15)',
  zIndex: 1,
}))

const StyledBadge = styled(Badge)`
  &.MuiBadge-root {
    position: absolute;
    bottom: 28px;
    right: 8px;
  }
  & .MuiBadge-badge {
    width: fit-content;
    height: fit-content;
    padding: 0;
  }
`

interface Props {
  onSubmit: (caption: string) => void
  selectionCount: number
}

export const FORWARD_CAPTION_HEIGHT = 55

export function ForwardCaption({ onSubmit, selectionCount }: Props) {
  const [text, setText] = useState<string>('')
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        padding: '2px 61px 2px 8px',
        backgroundColor: 'white',
        borderTop: '1px solid #0000001A',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
      }}
    >
      <StyledBadge
        overlap="circular"
        invisible={!selectionCount}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={
          selectionCount ? (
            <StyledDiv>{toLocale(selectionCount)}</StyledDiv>
          ) : null
        }
      >
        <StyleIconButton onClick={() => onSubmit(text)}>
          <ForwardSendIcon />
        </StyleIconButton>
      </StyledBadge>

      <TextEditor
        action={undefined}
        mentionIsDisabled={false}
        darkMode={false}
        placeholder={t('chat.sendField')}
        setHasMessage={nothing}
        onContentChange={setText}
        setMentionQuery={nothing}
        onSubmit={() => onSubmit(text)}
        onPasteFile={nothing}
        resetSendFieldAction={nothing}
        resetSendField={nothing}
      />

      {!isPhoneOrTablet && (
        <IconButton
          onClick={(e: MouseEvent) => {
            e.stopPropagation()
            toggleEmojiPicker()
          }}
        >
          <EmojiIcon />
        </IconButton>
      )}
    </div>
  )
}
